import React, { Component } from 'react'
import { FormBox, CustomBox, Grid, GridContainer, GridCell } from 'common-controls/Core'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import * as queryString from 'query-string'
import signUp from './SignUp'
import forgotPassword from './ForgotPassword'
import { RegisterDevice, RegisterDeviceEvents } from './RegisterDevice'
import { UpdateAgreement, UpdateAgreementEvent } from './UpdateAgreement'
import { DrawerSizeOptions } from 'common-controls/Drawer/index'
import { log, componentGetCompareProps, MessageBusWrapper } from 'common-tools/index'
// import { OauthSender, OauthReceiver } from 'react-oauth-flow'
import fetch from 'node-fetch'
import _ from 'lodash'
import ProfilePasswordChanges from 'common-views/Shared/ProfileAccount/ProfilePasswordChanges'
// import { LoginMessageBoardSearch } from './LoginMessageBoard/LoginMessageBoardSearch'

/*
const googleKeys = require('../Security/OAuth/google_key.json')

let googleRedirectUri = ''
let googleOrigins = ''
let oauthState = ''

if (process.env.NODE_ENV !== 'production') {
  googleOrigins = googleKeys.web.javascript_origins.dev
  googleRedirectUri = googleKeys.web.redirect_uris.dev
  oauthState = '/login'
} else {
  googleOrigins = googleKeys.web.javascript_origins.prod
  googleRedirectUri = googleKeys.web.redirect_uris.prod
  oauthState = '/App'
} */

class LoginPlain extends Component {
  constructor (props) {
    super(props)
    this.state = {
      initialValues: {
      },
      loginAuth: { extraToken: {}, authAccountInfo: {} }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const deviceFingerPrint = componentGetCompareProps('SessionDeviceFingerPrint', this.props, prevProps, 'FFFFFFFF')
    // log.Trace('Device Finger Print Props', { Print: deviceFingerPrint })
    const { formSetFieldValue } = this.props

    if (deviceFingerPrint.HasChanged === true) {
      formSetFieldValue('Login', 'DeviceFingerPrint', deviceFingerPrint.Current.Id)
      formSetFieldValue('Login', 'DeviceUserAgent', deviceFingerPrint.Current.UserAgent)
    }
  }

  componentDidMount () {
    const { clearUser, GetBuildNumber } = this.props
    document.body.classList.toggle('login-blue-bg', true)
    try {
      clearUser()
      GetBuildNumber()
    } catch (err) {
      log.Error('Failed Clear Agency User:', { Error: err })
    }
  }

  onSignUp () {
    const { openDrawer, MessageBusKey } = this.props
    openDrawer(signUp, MessageBusKey, null, DrawerSizeOptions.Middle)
  }

  onForgotPassword () {
    const { openDrawer, MessageBusKey } = this.props
    openDrawer(forgotPassword, MessageBusKey, null, DrawerSizeOptions.Middle)
  }

  onSendToLogin (extraToken, authAccountInfo) {
    const { sendToURL, location, setAccount } = this.props
    setAccount(extraToken, authAccountInfo)
    let queryVars = queryString.parse(location.search)
    sendToURL(queryVars.returnURL || '/App')
  }

  onNewMessage (message) {
    const { extraToken, authAccountInfo } = this.state.loginAuth
    switch (message.Type) {
      case RegisterDeviceEvents.Success:
      case UpdateAgreementEvent.Success:
        this.onSendToLogin(extraToken, authAccountInfo)
        break
    }
  }

  onGoogleOAuth (url) {
    const { sendToURL } = this.props
    sendToURL(url)
  }

  onChangePassword () {
    const { openDrawer, MessageBusKey } = this.props
    openDrawer(ProfilePasswordChanges, MessageBusKey, { SessionAccountKey: this.state.loginAuth.authAccountInfo._key }, DrawerSizeOptions.Static)
  }

  onRegisterDevice () {
    const { openDrawer, MessageBusKey } = this.props
    openDrawer(RegisterDevice, MessageBusKey, { SessionAccountKey: this.state.loginAuth.authAccountInfo._key }, DrawerSizeOptions.Middle)
  }

  onUpdateAgreement (agreements) {
    const { openDrawer, MessageBusKey } = this.props
    openDrawer(
      UpdateAgreement,
      MessageBusKey,
      {
        SessionAccountKey: this.state.loginAuth.authAccountInfo._key,
        Agreements: agreements
      },
      DrawerSizeOptions.Middle)
  }

  async handleAuthSuccess (accessToken, { response, state }) {
    const { sendToURL, formCheckForSubmissionErrors, AccountLogin, SessionDeviceFingerPrint } = this.props

    const userInfoResponse = await fetch(`https://www.googleapis.com/oauth2/v3/userinfo?alt=json&access_token=${accessToken}`)
    const userInfoJson = await userInfoResponse.json()

    return AccountLogin(
      {
        LoginId: userInfoJson.email,
        Password: accessToken,
        IsOAuth: true,
        DeviceFingerPrint: SessionDeviceFingerPrint.Id,
        DeviceUserAgent: SessionDeviceFingerPrint.UserAgent
      })
      .then(({ data, extra }) => {
        log.Trace('Extra Data', { data: data })
        log.Trace('Data', { extra: extra })

        if (_.isEmpty(extra.Device)) {
          this.setState({
            loginAuth: { extraToken: extra.Token, authAccountInfo: data }
          })
          //this.onRegisterDevice()
        } else if (extra.OutdatedAgreements.length > 0) {
          this.setState({
            loginAuth: { extraToken: extra.Token, authAccountInfo: data }
          })
          this.onUpdateAgreement(extra.OutdatedAgreements)
        } else {
          this.onSendToLogin(extra.Token, data)
        }
      })
      .catch(formCheckForSubmissionErrors, sendToURL('/Login'))
  }

  onSubmit (values) {
    const { formCheckForSubmissionErrors, AccountLogin } = this.props

    return AccountLogin(
      {
        LoginId: values.LoginId,
        Password: values.Password,
        IsOAuth: false,
        DeviceFingerPrint: values.DeviceFingerPrint,
        DeviceUserAgent: values.DeviceUserAgent
      })
      .then(({ data, extra }) => {
        log.Trace('Extra Data', { data: data })
        log.Trace('Data', { extra: extra })

        // on going life this statement deleted and if block shoud be uncommented
        this.onSendToLogin(extra.Token, data)
        // on going life this section should be used
        //if (_.isEmpty(extra.Device)) {
        //this.setState({
        //loginAuth: { extraToken: extra.Token, authAccountInfo: data }
        //})
        //this.onRegisterDevice()
        // } else if (extra.OutdatedAgreements.length > 0) {
        //this.setState({
        //loginAuth: { extraToken: extra.Token, authAccountInfo: data }
        //})
        //this.onUpdateAgreement(extra.OutdatedAgreements)
        //} else {
        //this.onSendToLogin(extra.Token, data)
        //}
      }).catch(formCheckForSubmissionErrors)
  }

  render () {
    const { data, formSubmit } = this.props
    return (
      <div className="login-container">
        <GridContainer>
          <Grid>
            <GridCell small={4} className="login-white-bg">
              <div className="login-inner-container">
                <img src="/content/images/LogoText.png" />
                <FormBox form='Login' loading={data.loadingAccountLogin} onSubmit={this.onSubmit} initialValues={{ LoginId: '', Password: '' }} showButtons>
                  <Grid className="login-form">
                    <GridCell>
                      <CustomBox name='LoginId' noLayout>
                        {({ value = '', onChange, showError, errorMessage, loading = false }) =>
                          <label>
                            <input type="text" data-tid='login' onChange={onChange} disabled={loading} value={value} placeholder="Username" />
                            {errorMessage}
                          </label>
                        }
                      </CustomBox>
                    </GridCell>
                    <GridCell>
                      <CustomBox name='Password' noLayout>
                        {({ value = '', onChange, showError, errorMessage, loading = false }) =>
                          <label>
                            <input type="password" data-tid='password' onChange={onChange} disabled={loading} value={value} placeholder="Password" />
                            {errorMessage}
                          </label>
                        }
                      </CustomBox>
                    </GridCell>
                  </Grid>
                  <Grid>
                    <GridCell><a className="login-button expanded" href="#" onClick={() => { formSubmit('Login') }}>LOGIN</a></GridCell>
                    {/* <GridCell className="text-center">- or -</GridCell>
                    <GridCell>
                      <OauthSender
                        authorizeUrl={googleKeys.web.auth_uri}
                        clientId={googleKeys.web.client_id}
                        redirectUri={googleRedirectUri[0]}
                        state={{ from: oauthState }}
                        args={{ scope: 'openid email profile' }}
                        render={({ url }) => <a className="google-button expanded" disabled={data.loadingAccountLogin} onClick={() => { this.onGoogleOAuth(url) }} href="#">Sign in with Google</a>}
                      />
                    </GridCell> */}
                  </Grid>
                </FormBox>
                <Grid>
                  <GridCell large={6}><a href="#" loading={data.loadingAccountLogin} onClick={() => { this.onSignUp() }}>Create Account</a></GridCell>
                  <GridCell large={6} className="text-right"><a href="#" disabled={data.loadingAccountLogin} onClick={() => { this.onForgotPassword() }}>Forgot Password?</a></GridCell>
                </Grid>
              </div>
              <Grid>
                <GridCell className="text-right login-build login-build">{data.BuildNumber ? data.BuildNumber.Number : ''}</GridCell>
              </Grid>
            </GridCell>
            <GridCell small={8} className='login-img-bg'>
              <div className="login-overlay">
                <div className="login-title-box">
                  <div className="login-title">Number One <span>In Home Health Care(Alpha)</span></div>
                </div>
              </div>
            </GridCell>
          </Grid>
        </GridContainer>

        {/* <React.Fragment>
          <OauthReceiver
            tokenUrl={googleKeys.web.token_uri}
            clientId={googleKeys.web.client_id}
            clientSecret={googleKeys.web.client_secret}
            redirectUri={googleRedirectUri[0]}
            onAuthSuccess={this.handleAuthSuccess}
            onAuthError={this.handleError}
            render={({ processing, state, error }) => (
              <div>
                {processing && <p>Authorizing with Google ...</p>}
                {error
                  ? <p className="error">An error occured: {error.message}</p>
                  : null
                }
              </div>
            )}
          />
        </React.Fragment> */}
      </div >
    )
  }
}

export const Login = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount,
    sh.SessionDeviceFingerPrint
  ], [
    ah.sendToURL,
    ah.setAppState,
    ah.formCheckForSubmissionErrors,
    ah.setUser,
    ah.clearUser,
    ah.setAccount,
    ah.openDrawer,
    ah.formSetFieldValue,
    ah.formSubmit,
    ah.openDrawer
  ]),
  QueryWrapper({
    key: 'Login',
    actions: [
      {
        url: '/Services/Security/Login',
        prop: 'AccountLogin',
        map: false
      },
      {
        url: '/Services/Data/BuildNumber/Get',
        prop: 'GetBuildNumber',
        map: 'BuildNumber'
      }
    ]
  }),
  MessageBusWrapper
)(LoginPlain)

export default Login
